import transformStatusCodeMsg from './transformStatusCodeMsg';
export default function setResponseMsg(response) {
    if (!response || (Array.isArray(response) && !response.length))
        return response;
    var result = Array.isArray(response) ? response[0] : response;
    if (result.hasOwnProperty('checkMsg'))
        result.checkMsg = transformStatusCodeMsg(result.checkMsg);
    if (result.hasOwnProperty('warning'))
        result.warning = transformStatusCodeMsg(result.warning);
    if (result.error && result.error.hasOwnProperty('errorMsg'))
        result.error.errorMsg = transformStatusCodeMsg(result.error.errorMsg);
    if (result.errorInfo && result.errorInfo.hasOwnProperty('errorMsg'))
        result.errorInfo.errorMsg = transformStatusCodeMsg(result.errorInfo.errorMsg);
    if (result.errorInfo && result.errorInfo.hasOwnProperty('description'))
        result.errorInfo.description = transformStatusCodeMsg(result.errorInfo.description);
    if (result.hasOwnProperty('showMsg'))
        result.showMsg = transformStatusCodeMsg(result.showMsg);
    if (result.hasOwnProperty('responseMessage'))
        result.responseMessage = transformStatusCodeMsg(result.responseMessage);
    if (result.hasOwnProperty('message')) {
        if (typeof result.message !== "object") {
            result.message = transformStatusCodeMsg(result.message ? result.message : '');
        }
        else {
            if (typeof result.message === "object" && result.message !== null)
                result.message.exceptionMsg = result.message.exceptionMsg ? transformStatusCodeMsg(result.message.exceptionMsg) : '';
        }
    }
    if (Array.isArray(response))
        return [result];
    return result;
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/setResponseMsg.js
// module id = null
// module chunks = 